import { observer } from "mobx-react";
import React, { useEffect, useRef, useState } from "react";
import { Dimensions, StyleSheet, View } from "react-native";
import MaterialTabs from "react-native-material-tabs";
import { RFValue } from "react-native-responsive-fontsize";
import CustomHeader from "../../components/CustomHeader";
import MenuIcon from "../../components/icons/MenuIcon";
import Notarize from "../../components/table/Notarize";
import POI from "../../components/table/POI";
import getNotarizeResults from "../../networking/api/verification/getNotarizeResults";
import getPoiResults from "../../networking/api/verification/getPoiResults";
import state from "../../store/Store";
import BottomSheet from "reanimated-bottom-sheet";
import RejectionReason from "../../components/notarize/RejectionReason";
import { TouchableWithoutFeedback } from "react-native";
import getDisputes from "../../networking/api/verification/getDisputes";
import Dispute from "../../components/table/Dispute";
import CloseIcon from "../../components/icons/CloseIcon";

const { height, width } = Dimensions.get("window");

const NotarizeDispute = observer(({ navigation }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { uid } = state;

  useEffect(() => {
    getDisputes(
      uid,
      (e) => setData(e),
      (e) => setLoading(e)
    );
  }, [uid]);

  return (
    <View style={styles.container}>
      <CustomHeader
        title="Disputes"
        leftIcon={<CloseIcon navigation={navigation} />}
      />
      <Dispute data={data} loading={loading} />
    </View>
  );
});

export default NotarizeDispute;

const styles = StyleSheet.create({
  container: { flex: 1 },
  textStyle: { fontFamily: "avenir", fontSize: RFValue(10) },
});
